module.exports = __webpack_public_path__ + "static/img/ubg8.09e5a591.png";